<template>
  <div class="field">
    <div v-if="edit" class="control">
      <input
        ref="input"
        class="input"
        type="text"
        placeholder="..."
        v-model="text"
        @blur="handleChange"
      />
    </div>
    <div v-else>
      <span @click="activateEdit">{{ text || 'create' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableCellEditableInput',
  props: {
    payload: {
      type: Object,
      required: true
    },
    additional_data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      edit: false,
      text: ''
    }
  },
  created () {
    this.text = this.payload[this.additional_data.field]
  },
  methods: {
    activateEdit () {
      this.edit = true
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.$refs.input.focus()
        }
      })
    },
    async handleChange () {
      try {
        // Call the update function to update the database
        await this.$network_utils[this.additional_data.function]({ [this.additional_data.id]: this.payload[this.additional_data.resoutceId], [this.additional_data.field]: this.text })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'Failed to update' })
      } finally {
        this.edit = false // Exit edit mode
      }
    }
  }
}
</script>
